exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-header[data-v-7db0858f]{padding:0;border-bottom:none}[data-v-7db0858f] .el-form-item{margin-bottom:10px;margin-right:10px}.table-box[data-v-7db0858f] .el-table th{background-color:#f7fbff}\n", ""]);

// exports
